"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "setCanStartStream", {
  enumerable: true,
  get: function get() {
    return _setCanStartStream["default"];
  }
});
Object.defineProperty(exports, "startStream", {
  enumerable: true,
  get: function get() {
    return _startStream["default"];
  }
});
Object.defineProperty(exports, "startStreams", {
  enumerable: true,
  get: function get() {
    return _startStreams["default"];
  }
});
Object.defineProperty(exports, "stopStream", {
  enumerable: true,
  get: function get() {
    return _stopStream["default"];
  }
});
Object.defineProperty(exports, "stopStreams", {
  enumerable: true,
  get: function get() {
    return _stopStreams["default"];
  }
});
Object.defineProperty(exports, "syncEndpoints", {
  enumerable: true,
  get: function get() {
    return _syncEndpoints["default"];
  }
});
var _startStream = _interopRequireDefault(require("./startStream"));
var _stopStream = _interopRequireDefault(require("./stopStream"));
var _startStreams = _interopRequireDefault(require("./startStreams"));
var _stopStreams = _interopRequireDefault(require("./stopStreams"));
var _syncEndpoints = _interopRequireDefault(require("./syncEndpoints"));
var _setCanStartStream = _interopRequireDefault(require("./setCanStartStream"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }